import React, { useState } from 'react';
import { QUOTE_LINE_SELECTED_STATES } from '../../pages/WMS_SMS/data';
import { WMSFetch } from '../../utils/common-api-calls';

export default function SelectAllQuoteLinesButton({
    data,
    currentUser,
    setData,
    setSelectedQuoteLines,
    setShowNotification,
}) {
    const [selectModeIndex, setSelectModeIndex] = useState(0);
    const selectModes = ['No Quote All', 'Lock All', 'NONE', 'Select All Quote Lines'];

    const bulkUpdateQuoteLineState = (newState) => {
        const updatedQuotes = data?.quotes?.map((quote) => {
            if (quote.currentStep) return quote;

            return {
                ...quote,
                selectedState: newState,
                email: currentUser.authentication.userEmail,
                currentStep: null,
            };
        });

        setData((prevData) => ({
            ...prevData,
            quotes: updatedQuotes,
        }));

        const updatedLineNumbers = updatedQuotes
            .filter((quote) => quote.selectedState === newState || quote.selectedState === QUOTE_LINE_SELECTED_STATES.LOCKED)
            .map((quote) => quote.quoteLineNumber);

        setSelectedQuoteLines(updatedLineNumbers);
    };

    const bulkUpdateLockedStatus = async (data) => {
        try {
            const response = await WMSFetch('wms/sms/toggle-lock-status-bulk', { data }, currentUser);
            if (response?.error) {
                throw Error(response.Error);
            }
        } catch (error) {
            setShowNotification({
                shown: true,
                status: 'error',
                title: 'Error updating lock status',
                message:
                    'An error has occured updating the lock status for the selected quote. If the error persists please contact your manager.',
            });
        }
    };

    const bulkLockQuoteLines = async () => {
        const lockUpdates = [];
        const updatedQuotes = data?.quotes?.map((quote) => {
            if (quote.currentStep) return quote;

            if (quote.selectedState === QUOTE_LINE_SELECTED_STATES.LOCKED) {
                return quote;
            }

            lockUpdates.push({ autoId: quote.autoId, isLocked: true });

            return {
                ...quote,
                selectedState: QUOTE_LINE_SELECTED_STATES.LOCKED,
                email: currentUser.authentication.userEmail,
                currentStep: null,
            };
        });

        setData((prevData) => ({
            ...prevData,
            quotes: updatedQuotes,
        }));

        const selectedLineNumbers = updatedQuotes.map((q) => q.quoteLineNumber);
        setSelectedQuoteLines(selectedLineNumbers);

        await bulkUpdateLockedStatus(lockUpdates);
    };

    const deselectAllQuoteLines = async () => {
        const quoteLinesToUnlock = data?.quotes
            ?.filter((quote) => !quote.currentStep && quote?.selectedState === QUOTE_LINE_SELECTED_STATES.LOCKED)
            .map((quote) => ({
                autoId: quote.autoId,
                selectedState: null,
                requestedDate: null,
            }));

        const updatedQuotes = data?.quotes?.map((quote) => {
            if (quote.currentStep) return quote;

            return {
                ...quote,
                email: null,
                selectedState: null,
            };
        });

        setData((prevData) => ({
            ...prevData,
            quotes: updatedQuotes,
        }));

        setSelectedQuoteLines([]);

        if (quoteLinesToUnlock.length > 0) {
            await bulkUpdateLockedStatus(quoteLinesToUnlock);
        }
    };

    return (
        <button
            onClick={async () => {
                const mode = selectModes[selectModeIndex];

                switch (mode) {
                    case 'Select All Quote Lines':
                        bulkUpdateQuoteLineState(QUOTE_LINE_SELECTED_STATES.SELECT);
                        break;

                    case 'No Quote All':
                        bulkUpdateQuoteLineState(QUOTE_LINE_SELECTED_STATES.NO_QUOTE);
                        break;

                    case 'Ignore All':
                        bulkUpdateQuoteLineState(QUOTE_LINE_SELECTED_STATES.IGNORE);
                        break;
                    case 'Lock All':
                        bulkLockQuoteLines();
                        break;
                    case 'NONE':
                        deselectAllQuoteLines();
                        break;
                }

                // Cycle to next mode
                setSelectModeIndex((prev) => (prev + 1) % selectModes.length);
            }}
            className='px-4 py-2 text-white whitespace-nowrap rounded-md bg-blue-primary'
        >
            {selectModes[selectModeIndex] === 'NONE' ? 'Deselect All Quote Lines' : `${selectModes[selectModeIndex]}`}
        </button>
    );
}
